import { ChecklistItemRow } from "../../../models/pages/checklists/checklists-list.model";
import UiTable from "../../../components/table/Table.component";
import { TableColumnTemplate } from "../../../models/components/table/table-column.model";
import { TableStyle } from "../../../models/components/table/table.model";
import { useContext, useState } from "react";
import { TablePagination } from "../../../models/components/table/table-pagination.model";
import { StoredCriteriaService } from "../../../services/session/stored-criteria.service";

import { useUpdateChecklistItem } from "./useUpdateChecklistItem";
import { ParticipantContext } from "../../../contexts/Participant.context";
import { ParticipantContextProps } from "../../../models/contexts/participant-context.model";

const ChecklistsNestedList = ({
	rows,
	checklistId,
}: {
	rows: ChecklistItemRow[] | undefined;
	checklistId: number;
}) => {
	// Pagination
	const [pagination, _setPagination] = useState<TablePagination>(
		StoredCriteriaService.getPagination(StoredCriteriaService.KEYS["checklists"]) ?? {
			first: 0,
			rows: 20,
			page: 0,
			sortField: undefined,
			sortOrder: undefined,
			search: undefined,
			filters: undefined,
		}
	);

	const updateChecklistItem = useUpdateChecklistItem();
	const participantContext = useContext<ParticipantContextProps>(ParticipantContext);

	return (
		<UiTable
			dataKey="type"
			type={TableStyle.NESTED}
			tableClassName="nested-table"
			useAsCard={false}
			pagination={pagination}
			paginator={false}
			rowClassName={() => "inline-form"}
			value={rows}
			columns={[
				{
					field: "name",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.NAME",
					sortable: false,
					template: TableColumnTemplate.TRANSLATE,
				},
				{
					field: "completed",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.COMPLETED",
					sortable: false,
					template: TableColumnTemplate.BOOLEAN,
					style: {
						width: "100px",
						textAlign: "center",
					},
					onChange(event, rowData) {
						updateChecklistItem.mutateAsync({
							id: rowData.id,
							checkListId: checklistId,
							patientId: participantContext.participant!.id,
							completed: event.target.value,
							isCompletedOverride: rowData.completed !== event.target.value,
							applicable: rowData.applicable,
							isApplicableOverride: rowData.isApplicableOverride,
						});
					},
				},
				{
					field: "applicable",
					title: "PARTICIPANT.CHECKLISTS.LIST.COLUMNS.APPLICABLE",
					sortable: false,
					template: TableColumnTemplate.BOOLEAN,
					style: {
						width: "100px",
						textAlign: "center",
						paddingRight: "190px",
					},
					onChange(event, rowData) {
						updateChecklistItem.mutateAsync({
							id: rowData.id,
							checkListId: checklistId,
							patientId: participantContext.participant!.id,
							completed: rowData.completed,
							isCompletedOverride: rowData.isCompletedOverride,
							applicable: event.target.value,
							isApplicableOverride: rowData.applicable !== event.target.value,
						});
					},
				},
			]}
		/>
	);
};
export default ChecklistsNestedList;
